import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home h-100 with-dots" }
const _hoisted_2 = { class: "container h-100" }
const _hoisted_3 = {
  class: "profile-card",
  ref: "card"
}
const _hoisted_4 = { class: "cta-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array($setup.amountDots), (p, index) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "dot",
        key: index
      }))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, [
          _createTextVNode(" FRONT"),
          _createElementVNode("br"),
          _createTextVNode(" DEV ")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, [
          _createTextVNode(" Hola, "),
          _createElementVNode("br"),
          _createTextVNode(" Soy "),
          _createElementVNode("b", null, "Patricio Rojas"),
          _createTextVNode(),
          _createElementVNode("br"),
          _createTextVNode(" Desarrollador Web Fullstack, especializado en Frontend "),
          _createElementVNode("br"),
          _createTextVNode(" Temuco, Chile ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/examples",
            class: "cta-button"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Ver mis proyectos ", -1),
              _createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createStaticVNode("<p class=\"social-links\"><a href=\"https://github.com/brujo-rojas\" target=\"_blank\" class=\"chip\"><i class=\"fa fa-github\"></i><span class=\"platform-name\">GitHub</span></a><a href=\"https://codepen.io/brujo696\" target=\"_blank\" class=\"chip\"><i class=\"fa fa-codepen\"></i><span class=\"platform-name\">CodePen</span></a><a href=\"https://www.linkedin.com/in/patriciorojasr/\" target=\"_blank\" class=\"chip\"><i class=\"fa fa-linkedin\"></i><span class=\"platform-name\">LinkedIn</span></a></p>", 1))
      ], 512)
    ])
  ]))
}